<template>
  <v-app>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      temporary
      app
      class="hidden-md-and-up"
    >
      <v-list>
        <v-list-tile
          value="true"
          active-class=""
          exact-active-class="primary--text"
          v-for="(item, i) in items"
          :key="i"
          :to="{ name: item.route }"
          exact
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      dark
      :clipped-left="clipped"
    >
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
      />
<!--      <v-btn icon @click.stop="miniVariant = !miniVariant">-->
<!--        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>-->
<!--      </v-btn>-->
<!--      <v-btn icon @click.stop="clipped = !clipped">-->
<!--        <v-icon>web</v-icon>-->
<!--      </v-btn>-->
<!--      <v-btn icon @click.stop="fixed = !fixed">-->
<!--        <v-icon>web</v-icon>-->
<!--      </v-btn>-->
      <v-toolbar-title v-text="title" class="logo"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="(item, i) in items"
          :key="i"
          :to="{ name: item.route }"
          flat
          exact
        >
<!--          <v-icon v-html="item.icon" left />-->
          {{item.title}}
        </v-btn>
      </v-toolbar-items>
      <!--<v-btn icon @click.stop="rightDrawer = !rightDrawer">-->
        <!--<v-icon>menu</v-icon>-->
      <!--</v-btn>-->
    </v-toolbar>
    <vue-progress-bar></vue-progress-bar>
    <v-content>
      <v-slide-y-transition mode="out-in">
        <keep-alive include="explore">
          <router-view/>
        </keep-alive>
      </v-slide-y-transition>
    </v-content>
    <!--<v-navigation-drawer-->
      <!--temporary-->
      <!--:right="right"-->
      <!--v-model="rightDrawer"-->
      <!--fixed-->
      <!--app-->
    <!--&gt;-->
      <!--<v-list>-->
        <!--<v-list-tile @click="right = !right">-->
          <!--<v-list-tile-action>-->
            <!--<v-icon>compare_arrows</v-icon>-->
          <!--</v-list-tile-action>-->
          <!--<v-list-tile-title>Switch drawer (click me)</v-list-tile-title>-->
        <!--</v-list-tile>-->
      <!--</v-list>-->
    <!--</v-navigation-drawer>-->
    <f-a-b/>
    <v-footer
      :fixed="fixed"
      height="auto"
    >
      <v-flex text-xs-center xs12 class="py-3">
        <span class="subheading font-weight-bold">
          BBCancer &copy; 2019 The Ren Lab. All Rights Reserved
        </span>
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>
import FAB from './components/TheFAB.vue';

export default {
  name: 'App',
  components: {
    FAB,
  },
  data() {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'home',
          title: 'Home',
          route: 'home',
        },
        {
          icon: 'explore',
          title: 'Explore',
          route: 'explore',
        },
        {
          icon: 'search',
          title: 'Browse',
          route: 'biomarkers',
        },
        {
          icon: 'poll',
          title: 'Statistics',
          route: 'statistics',
        },
        {
          icon: 'cloud_download',
          title: 'Download',
          route: 'download',
        },
        {
          icon: 'help',
          title: 'Help',
          route: 'help',
        },
        {
          icon: 'contacts',
          title: 'Contacts',
          route: 'contacts',
        },
      ],
      miniVariant: false,
      // right: true,
      // rightDrawer: false,
      title: 'BBCancer',
    };
  },
  created() {
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
  .logo {
    font-family: 'Lobster', cursive;
    font-size: 24px;
    font-weight: bold;
  }
</style>

<style lang="scss">
  a:hover {
    color: var(--v-primary-base);
  }

  .v-navigation-drawer {
    & > .v-list {
      a:hover {
        text-decoration: none;
      }
    }
  }

  .v-toolbar__content {
    .v-toolbar__items {
      a:hover {
        text-decoration: none;
      }
    }
  }
</style>
